export default __webpack_public_path__ + "static/media/title_en_pc@2x.c3db5073.png";